import { Component, OnInit } from '@angular/core';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

import { Comprobante } from '../../../models/comprobante';
import { ComprobanteService } from '../../../services/comprobante.service';
import { TipoComprobanteService } from '../../../services/tipo-comprobante.service';
import { SessionService } from '../../../services/session.service';
import { Validation } from '../../../config/validation';
import { SweetMessage } from '../../../config/sweet-message';

import { CajaService } from '../../../services/caja.service';
import { Block } from '../../../models/block';
import { BlockService } from '../../../services/block.service';

import { Router } from '@angular/router';

declare var $;

@Component({
	selector: 'app-comprobante-edit',
	templateUrl: './comprobante-edit.component.html',
	styleUrls: ['./comprobante-edit.component.css'],
	providers: [ComprobanteService, CajaService, TipoComprobanteService, BlockService,SessionService]
})
export class ComprobanteEditComponent implements OnInit {
	public title: String;
	public comprobante: Comprobante;
	public msg: SweetMessage;
	myForm: FormGroup;
	public vl: Validation;
	public cajas;
	public tipos;
	public blocks: Array<Block> = [];
	public enabledButton: boolean = false;
	private validDateEmision;
	private block: Block;
	private validDateCaducidad;
	public loading = false;

	constructor(
		private ComprobanteService: ComprobanteService,
		private tipoComprobanteService: TipoComprobanteService,
		private cajaService: CajaService,
		private storage: AsyncLocalStorage,
		private blockService: BlockService,
		public fb: FormBuilder,
		private ss: SessionService,
		private NavRoute: Router,
	) {
		this.title = "Editar Comprobante";
	}

	ngOnInit() {
		this.block = new Block();
		//Inicializar Formulario
		this.onForm();
		//Inicializacion de Objectos
		this.msg = new SweetMessage();
		//Inicializacion de Objecto de validacion
		this.vl = new Validation();
		//Inicializacion de objecto Comprobante
		this.comprobante = new Comprobante();
		this.tipos = [];
		this.getCaja();
		this.getTipoComprobante();
		this.storage.getItem("comprobante").subscribe(data => {
			//Asignacion de los datos almacenados en el IndexedDB
			this.comprobante = data;
			//Asignar valores al formulario
			this.setValueForm();

		});
	}

	getCaja() {
		this.loading = true;
		this.cajaService.getAll().subscribe(
			res => {
				this.loading = false;
				this.cajas = res.data;
			},
			err => {
				this.loading = false;
				this.cajas = [];
			});
	}

	/*sendBlock() {
		this.block.fecha_emision = this.myForm.controls['fecha_emision'].value;
		this.block.fecha_caducidad = this.myForm.controls['fecha_caducidad'].value;
		this.block.secuencial_inicio = this.myForm.controls['secuencial_inicial'].value;
		this.block.secuencial_fin = this.myForm.controls['secuencial_fin'].value;

		this.block.empresa_id = this.ss.getData('empresa_id');
		this.block.sucursal_id = this.ss.getData('sucursal_id');
		this.block.usuario_id = this.ss.getData('usuario_id');

		this.block.comprobante_id = this.comprobante.id;
		this.blockService.save(this.block).subscribe(
			res => {
				this.msg.showMessage('success-message', res.message);
				this.getBlocks();
				this.blocks.push(this.block);
				this.myForm.patchValue({
					secuencial: this.block.secuencial_inicio
				});
			},
			err => {
				this.msg.showMessage('error-message', err);
			}
		);

	}*/

	getTipoComprobante() {
		this.loading = true;
		this.tipoComprobanteService.getAll().subscribe(
			res => {
				this.loading = false;
				this.tipos = res.data;
			},
			err => {
				this.loading = false;
				this.tipos = [];
			});
	}

	onEnabledButton() {
		let tmp = this.blocks.find(x => x.status == "A");
		if (tmp)
			return this.enabledButton = true;
		else
			return this.enabledButton = false;
	}

	onSubmit() {
		//setea valores del formulario a la entidad
		this.setValueEntity();
		this.loading = true;
		this.ComprobanteService.update(this.comprobante).subscribe(
			res => {
				this.loading = false;
				this.msg.showMessage('success-message', res.message);

				this.NavRoute.navigate(['/ventas/comprobantes-list'])
			},
			err => {
				this.loading = false;
				this.msg.showMessage('error-message', err);
			}
		);
	}

	openDialog() {
		$("#block-modal").appendTo("body").modal("show");
	}

	onForm() {
		this.myForm = this.fb.group({
			secuencial: [{ value: '', disabled: false },
			[Validators.required]],
			caja_id: [{ value: '', disabled: true }, [Validators.required]],
			tipo_comprobante_id: [{ value: '', disabled: true }, [Validators.required]],
			secuencial_inicial: ['', [Validators.required, Validators.pattern(/[0-9]/)]],
			secuencial_fin: ['', [Validators.required, Validators.pattern(/[0-9]/)]],
			fecha_caducidad: [new Date().toISOString().substring(0,10), [Validators.required]],
			fecha_emision: [new Date().toISOString().substring(0,10) , [Validators.required]],
			numero_autorizacion: ['',[Validators.required]]
		});
	}

	setValueEntity() {
		this.comprobante.secuencial = this.myForm.controls['secuencial'].value;
		this.comprobante.caja_id = this.myForm.controls['caja_id'].value;
		this.comprobante.tipo_comprobante_id = this.myForm.controls['tipo_comprobante_id'].value;
		this.comprobante.blocks = this.blocks;
		this.comprobante.empresa_id = this.ss.getData('empresa_id');
		this.comprobante.sucursal_id = this.ss.getData('sucursal_id');
		this.comprobante.usuario_id = this.ss.getData('usuario_id');
		//Datos del block
		this.block.fecha_emision = this.myForm.controls['fecha_emision'].value;
		this.block.fecha_caducidad = this.myForm.controls['fecha_caducidad'].value;
		this.block.secuencial_inicio = this.myForm.controls['secuencial_inicial'].value;
		this.block.secuencial_fin = this.myForm.controls['secuencial_fin'].value;
		this.block.empresa_id = this.ss.getData('empresa_id');
		this.block.sucursal_id = this.ss.getData('sucursal_id');
		this.block.usuario_id = this.ss.getData('usuario_id');
		this.block.comprobante_id = this.comprobante.id;
		this.block.numero_autorizacion = this.myForm.controls['numero_autorizacion'].value;

		this.comprobante.block = this.block;
		this.comprobante.blocks.push(this.block);
	}

	validErrorForm(campo) {
		return this.vl.validErrorForm(campo, this.myForm);
	}

	validTypeMsgForm(nombre, campo) {
		return this.vl.validTypeMsgForm(nombre, campo, this.myForm);
	}

	setValueForm() {
		this.myForm.patchValue({
			secuencial: this.comprobante.secuencial,
			caja_id: this.comprobante.caja_id,
			tipo_comprobante_id: this.comprobante.tipo_comprobante_id,
		});
		this.getBlocks();
	}

	getBlocks() {
		this.blockService.getAll("?comprobante_id=" + this.comprobante.id).subscribe(
			res => {
				this.blocks = res;
			},
			err => {

			}
		);
	}

	onValidDateEmision() {
		this.block.fecha_emision = this.myForm.controls['fecha_emision'].value;
		this.validDateEmision = this.vl.validDateYYYY(this.block.fecha_emision.toString());
		return this.validDateEmision;
	}

	onValidDateCaducidad() {
		this.block.fecha_caducidad = this.myForm.controls['fecha_caducidad'].value;
		this.validDateCaducidad = this.vl.validDateYYYY(this.block.fecha_caducidad.toString());
		return this.validDateCaducidad;
	}

	onDelete(id) {
		this.msg.showMessage('delete-confirm-message').then(
			res => {
				if (res == "ok") {
					this.loading = true;
					this.blockService.delete(id).subscribe(
						res => {
							this.loading = false;
							if (res.message) {
								this.msg.showMessage('success-message', res.message);
								this.getBlocks();
							}
						},
						err => {
							this.loading = false;
							this.msg.showMessage('error-message', err);
						}
					);
				}
			}
		);
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/comprobante-edit/comprobante-edit.component.ts